module.exports = __webpack_public_path__ + "f8d88900a3fada84ba4da4680f6cfc1c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/firefox.png
 ** module id = 27
 ** module chunks = 0
 **/